let dragStartedAtX = 0;
let dragStartedAtY = 0;

let selectedragStartedX = 0;
let selectedragStartedY = 0;

let dragged = false;

export default class Mouse {
    constructor() {
        // p5.mousePressed = this.mousePressed
        // p5.mouseReleased = this.mouseReleased
        // p5.mouseDragged = this.mouseDragged
        // this.x = p5.mouseX
        // this.y = p5.mouseY
    }

    updatePosition() {
        // this.x = p5.mouseX
        // this.y = p5.mouseY
    }
    
    mousePressed() {
        // if (
        //     p5.mouseX > 0 &&
        //     p5.mouseY > 0 &&
        //     p5.mouseX < p5.width &&
        //     p5.mouseY < p5.height
        //   ) {
        //     console.log("Clicked in the canvas");
        //     if (this.hover) {
        //       this.$emit("nodeClickedInCanvas", this.hover);
        //     }
        //   }
  
        //   if (this.hover) {
        //     this.draggingObject = this.hover;
  
        //     this.draggingObjectCopy = this.draggingObject.copy();
        //     this.draggingObject.visible = false;
        //     dragStartedAtX = p5.mouseX;
        //     dragStartedAtY = p5.mouseY;
        //     selectedragStartedX = this.hover.x;
        //     selectedragStartedY = this.hover.y;
        //   }
    }


    mouseReleased() {
        if (dragged && this.draggingObject) {
          this.draggingObject.x = this.draggingObjectCopy.x;
          this.draggingObject.y = this.draggingObjectCopy.y;
          this.draggingObject.visible = true;
          this.draggingObject = null;
          this.draggingObjectCopy = null;
          // this.draggingObjectCopy
          dragged = false;
          console.log("Drag ended");
        }
      };


      mouseDragged() {
        if (!dragged) {
          dragged = true;
          dragStartedAtX = p5.mouseX;
          dragStartedAtY = p5.mouseY;
        }

        let draggedX = p5.mouseX - dragStartedAtX;
        let draggedY = p5.mouseY - dragStartedAtY;

        if (this.draggingObject) {
          this.draggingObjectCopy.x = selectedragStartedX + draggedX;
          this.draggingObjectCopy.y = selectedragStartedY + draggedY;
        }
      };
}